module.exports = __webpack_public_path__ + "static/media/27_CORTININHA_SEM_BOJO_ESTAMPADO_01.846124a6.jpg";